import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useState } from 'react';
import RichTextEditor from "react-rte/lib/RichTextEditor";
import { form_validator } from "../../form/FormFieldValidator";
import PropTypes from "prop-types";
import { FormContext } from "noood/contexts/contexts";
import * as stylex from "@stylexjs/stylex";
import Spacer from "noood/comp/ui/spacer/Spacer";
export default function RichTextfield(props) {
  var form_ = useContext(FormContext);
  var _useState = useState(function () {
      return RichTextEditor.createEmptyValue();
    }),
    _useState2 = _slicedToArray(_useState, 2),
    editor = _useState2[0],
    set_editor = _useState2[1];
  useEffect(function () {
    if (props.init_value) {
      var new_editor = RichTextEditor.createValueFromString(props.init_value, 'html');
      set_editor(new_editor);
    } else {
      set_editor(RichTextEditor.createEmptyValue());
    }
  }, [props.init_value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.label && /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, props.label), /*#__PURE__*/React.createElement("div", {
    className: "RichTextfield__ui.rte_container"
  }, /*#__PURE__*/React.createElement(RichTextEditor, {
    className: {
      className: "RichTextfield__ui.base evmkeg23 ev1y0btm7 ev6aoq2n ev2u8bby"
    }.className,
    toolbarClassName: {
      className: "RichTextfield__ui.toolbar ev1klv73h ev9ms5i6 evc342km ev1ghz6dp ev10w6t97 ev1ia1hqs ev1a2w583"
    }.className,
    editorClassName: {
      className: "RichTextfield__ui.editor evj6yrti ev160dt0k evfrllxf evjppbhk"
    }.className,
    toolbarConfig: {
      display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS'],
      INLINE_STYLE_BUTTONS: [{
        label: 'Bold',
        style: 'BOLD',
        className: {
          className: "RichTextfield__ui.button evc342km ev1717udv ev2u8bby evlrawln evezl2tj ev78zum5 ev6s0dn4 evl56j7k ev3azc8m evwnonoy"
        }.className
      }, {
        label: 'Italic',
        style: 'ITALIC',
        className: {
          className: "RichTextfield__ui.button evc342km ev1717udv ev2u8bby evlrawln evezl2tj ev78zum5 ev6s0dn4 evl56j7k ev3azc8m evwnonoy"
        }.className
      }, {
        label: 'Underline',
        style: 'UNDERLINE',
        className: {
          className: "RichTextfield__ui.button evc342km ev1717udv ev2u8bby evlrawln evezl2tj ev78zum5 ev6s0dn4 evl56j7k ev3azc8m evwnonoy"
        }.className
      }],
      BLOCK_TYPE_BUTTONS: [{
        label: 'UL',
        style: 'unordered-list-item',
        className: {
          className: "RichTextfield__ui.button evc342km ev1717udv ev2u8bby evlrawln evezl2tj ev78zum5 ev6s0dn4 evl56j7k ev3azc8m evwnonoy"
        }.className
      }, {
        label: 'OL',
        style: 'ordered-list-item',
        className: {
          className: "RichTextfield__ui.button evc342km ev1717udv ev2u8bby evlrawln evezl2tj ev78zum5 ev6s0dn4 evl56j7k ev3azc8m evwnonoy"
        }.className
      }]
    },
    autoFocus: false,
    value: editor,
    onChange: function onChange(v) {
      var _form_$__collect;
      set_editor(v);
      var html_val = v.toString('html');
      form_ === null || form_ === void 0 || (_form_$__collect = form_.__collect) === null || _form_$__collect === void 0 || _form_$__collect.call(form_, props.name, html_val, form_validator.validate(props.validations, html_val));
    }
  })), props.space && /*#__PURE__*/React.createElement(Spacer, {
    mtop: props.space
  }));
}
RichTextfield.propTypes = {
  init_value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  space: PropTypes.number
};

// @ts-ignore
_inject(".evmkeg23{border-width:1px}", 2000);
_inject(".ev1y0btm7{border-style:solid}", 2000);
_inject(".ev6aoq2n{border-color:var(--shade-lighter)}", 2000);
_inject(".ev2u8bby{border-radius:0}", 2000);
_inject(".ev1klv73h{background-color:var(--shade-dark)}", 3000);
_inject(".ev9ms5i6{padding:3px}", 1000);
_inject(".evc342km{border-width:0}", 2000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".ev10w6t97{height:32px}", 4000);
_inject(".ev1ia1hqs{border-top-left-radius:0}", 4000);
_inject(".ev1a2w583{border-top-right-radius:0}", 4000);
_inject(".evj6yrti{background-color:var(--shade-light)}", 3000);
_inject(".ev160dt0k{font-family:font1}", 3000);
_inject(".evfrllxf{border-bottom-left-radius:0}", 4000);
_inject(".evjppbhk{border-bottom-right-radius:0}", 4000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".evlrawln{height:25px}", 4000);
_inject(".evezl2tj{width:25px}", 4000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evl56j7k{justify-content:center}", 3000);
_inject(".ev3azc8m{transition:background .2s}", 2000);
_inject(".evwnonoy{background-color:var(--accent)}", 3000);
_inject(".evrkmrrc{background-color:red}", 3000);